// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"43872d01","568":"3dce6ea9"}[chunkId] + ".chunk.js";
};